/* eslint-disable */
import React from 'react';
import { StyleSheet, css } from 'aphrodite/no-important';

export default function HeaderBlack(props) {
  return (
    <div className={`header-black ${css(styles.flex, styles.flex_layout)}`}>
      <div className={css(styles.flex_item)}>
        <a
          href="https://www.daughter-tea.com/"
          onClick={() => window.open('https://www.daughter-tea.com/', '_self')}
          style={{
            '--src': `url(${
              require('assets/7166fc9748e36773d8bf58b2fb6df438.png').default
            })`
          }}
          className={`${css(styles.img, styles.img_layout)} cursor-pointer`}
        />
      </div>
      <div className={css(styles.flex_spacer)} />
      <h5 className={css(styles.highlights, styles.highlights_layout)}>
        {'分享至'}
      </h5>
      <div className={css(styles.flex_spacer1)} />
      <div className={css(styles.flex_item1)}>
        <a
          href="https://www.facebook.com/sharer/sharer.php?u=https://irori-tea-test.web.app/"
          onClick={() =>
            window.open(
              'https://www.facebook.com/sharer/sharer.php?u=https://irori-tea-test.web.app/',
              '_self'
            )
          }
          style={{
            '--src': `url(${
              require('assets/73e74e9652b28cb326014f50ebc8dcea.svg').default
            })`
          }}
          className={`${css(styles.icon, styles.icon_layout)} cursor-pointer`}
        />
      </div>
      <div className={css(styles.flex_spacer2)} />
      <div className={css(styles.flex_item2)}>
        <a
          href="http://twitter.com/share?text=茶測驗&url=https://irori-tea-test.web.app/&hashtags=你的五感靈魂是什麼風味樣貌？快來探索，獲得專屬你的茶風味推薦,茶測驗,女兒不懂茶,台東紅烏龍"
          onClick={() =>
            window.open(
              'http://twitter.com/share?text=茶測驗&url=https://irori-tea-test.web.app/&hashtags=你的五感靈魂是什麼風味樣貌？快來探索，獲得專屬你的茶風味推薦,茶測驗,女兒不懂茶,台東紅烏龍',
              '_self'
            )
          }
          style={{
            '--src': `url(${
              require('assets/cc19d560d4c66cbc1c5a944fd578f79e.png').default
            })`
          }}
          className={`${css(styles.image, styles.image_layout)} cursor-pointer`}
        />
      </div>
    </div>
  );
}

HeaderBlack.inStorybook = true;

const styles = StyleSheet.create({
  flex: {
    display: 'flex'
  },
  flex_layout: {
    position: 'relative',
    flexGrow: 1
  },
  flex_item: {
    display: 'flex',
    position: 'relative',
    flex: '0 0 auto',
    minWidth: 122
  },
  img: {
    background: 'var(--src) center center / cover no-repeat',
    display: 'block'
  },
  img_layout: {
    height: 39,
    width: 122,
    minWidth: 122
  },
  flex_spacer: {
    flex: '1 1 808px'
  },
  highlights: {
    display: 'flex',
    alignItems: 'center',
    font: '16px/1.75 "NotoSansCJKtc", Helvetica, Arial, serif',
    color: 'rgb(17,17,17)',
    letterSpacing: '0px'
  },
  highlights_layout: {
    flex: '0 0 auto',
    margin: '5.5px 0px',
    '@media (max-width: 575.98px)': {
      display: 'none'
    }
  },
  flex_spacer1: {
    flex: '0 0 auto',
    minWidth: 10
  },
  flex_item1: {
    display: 'flex',
    position: 'relative',
    flex: '0 0 auto',
    minWidth: 23
  },
  icon: {
    background: 'var(--src) center center / contain no-repeat',
    display: 'block'
  },
  icon_layout: {
    height: 23,
    width: 23,
    minWidth: 23,
    margin: '8px 0px'
  },
  flex_spacer2: {
    flex: '0 0 auto',
    minWidth: 23
  },
  flex_item2: {
    display: 'flex',
    position: 'relative',
    flex: '0 0 auto',
    minWidth: 23
  },
  image: {
    background: 'var(--src) center center / contain no-repeat',
    display: 'block'
  },
  image_layout: {
    height: 19,
    width: 23,
    minWidth: 23,
    margin: '10px 0px'
  }
});
